export function sanitize(value) {
    const text = to_string(value);
    return text.replace(/<\/?[^>]+(>|$)/g, '');
}

export function to_string(value) {
    switch (typeof value) {
        case 'string':
            return value;
        case 'number':
        case 'boolean':
        case 'bigint':
            return value + '';
        default:
            return JSON.stringify(value);
    }
}

export function build_query_string(params_list) {
    if (!Array.isArray(params_list)) {
        return '';
    }
    // convert to correct url key value pairs
    const cleanParams = params_list.map((param) => {
        const value = encodeURIComponent(sanitize(param.value));
        return `${param.key}=${value}`;
    });
    // combine
    const queryString = cleanParams.length > 0 ? `?${cleanParams.join('&')}` : '';
    return queryString;
}
